var _circle, _g, _circle2, _circle3, _g2, _circle4, _circle5, _g3, _path, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    fill: "white",
    fillOpacity: 0.07,
    stroke: "url(#paint0_radial_0_214)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_214)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    stroke: "url(#paint1_radial_0_214)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 17.5,
    fill: "url(#paint2_linear_0_214)",
    fillOpacity: 0.68
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 17.4,
    stroke: "url(#paint3_radial_0_214)",
    strokeOpacity: 0.7,
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_214)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 6,
    fill: "url(#paint4_linear_0_214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 5.9,
    stroke: "url(#paint5_radial_0_214)",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 35,
    height: 35
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.5,
    fill: "url(#paint6_linear_0_214)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.4,
    stroke: "url(#paint7_radial_0_214)",
    strokeOpacity: 0.76,
    strokeWidth: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_214)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 29,
    r: 6,
    fill: "url(#paint8_linear_0_214)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 29,
    r: 5.9,
    stroke: "url(#paint9_radial_0_214)",
    strokeWidth: 0.2
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2947 22.1759C36.2947 21.861 36.163 21.5589 35.9286 21.3362C35.6942 21.1135 35.3762 20.9884 35.0447 20.9884H20.8781C20.5465 20.9884 20.2286 21.1135 19.9942 21.3362C19.7597 21.5589 19.6281 21.861 19.6281 22.1759V25.7384H36.2947V22.1759ZM19.9073 31.5037L24.9806 26.6349L27.7223 29.1287L31.0731 26.346L32.9398 28.075",
    fill: "url(#paint10_linear_0_214)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_0_214)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_0_214",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3722 26.1888V33.8789C36.3722 34.2101 36.2344 34.5279 35.9891 34.7621C35.7437 34.9964 35.411 35.128 35.0641 35.128L22.4187 35.3489M25.5199 24.5233H33.3687H25.5199ZM22.0306 24.5233H22.9027H22.0306ZM18.9304 26.1888V29.9361V26.1888Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.3722 26.1888V33.8789C36.3722 34.2101 36.2344 34.5279 35.9891 34.7621C35.7437 34.9964 35.411 35.128 35.0641 35.128L22.4187 35.3489M25.5199 24.5233H33.3687H25.5199ZM22.0306 24.5233H22.9027H22.0306ZM18.9304 26.1888V29.9361V26.1888Z",
    fill: "url(#paint11_radial_0_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0641 35.128V34.8279L35.0588 34.828L35.0641 35.128ZM36.0722 26.1888V33.8789H36.6722V26.1888H36.0722ZM36.0722 33.8789C36.0722 34.126 35.9695 34.366 35.7819 34.5451L36.1963 34.9791C36.4993 34.6898 36.6722 34.2943 36.6722 33.8789H36.0722ZM35.7819 34.5451C35.5938 34.7248 35.3358 34.828 35.0641 34.828V35.428C35.4862 35.428 35.8937 35.268 36.1963 34.9791L35.7819 34.5451ZM35.0588 34.828L22.4135 35.0489L22.424 35.6489L35.0693 35.4279L35.0588 34.828ZM25.5199 24.8233H33.3687V24.2233H25.5199V24.8233ZM22.0306 24.8233H22.9027V24.2233H22.0306V24.8233ZM18.6304 26.1888V29.9361H19.2304V26.1888H18.6304Z",
    fill: "url(#paint12_linear_0_214)",
    fillOpacity: 0.1,
    mask: "url(#path-13-inside-1_0_214)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_0_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0096 39.9792C20.9209 39.8915 20.866 39.7703 20.866 39.6364C20.866 39.3686 21.0856 39.1515 21.3564 39.1515H23.8085C24.6184 39.1515 25.2798 38.4987 25.2798 37.697C25.2798 36.8952 24.619 36.2424 23.8053 36.2424H20.3769C19.9096 36.2424 19.1539 36.4187 18.7373 36.6246L14.7099 38.6155C14.4676 38.7352 14.173 38.6381 14.0519 38.3986C13.9308 38.1591 14.0289 37.8679 14.2712 37.7482L18.2986 35.7573C18.4101 35.7022 18.536 35.6496 18.6711 35.6007C16.9325 33.469 15.9618 30.8089 15.9618 28C15.9618 23.4332 18.5397 19.3245 22.5672 17.2438C22.5692 16.4308 22.988 15.6379 23.7452 15.1835L28.0896 12.5757C28.6298 12.2515 29.5353 12 30.1653 12H41.9369C42.2077 12 42.4273 12.2171 42.4273 12.4848C42.4273 12.7526 42.2077 12.9697 41.9369 12.9697H30.1653C29.7152 12.9697 28.9857 13.1723 28.5986 13.4046L24.2542 16.0123C23.5842 16.4145 23.3568 17.256 23.7209 17.9265C24.1667 18.5567 25.0479 18.7544 25.729 18.3617L29.0765 16.4311C29.6184 16.1186 30.5162 15.8788 31.1467 15.8788H35.088C35.3589 15.8788 35.5785 16.0959 35.5785 16.3636C35.5785 16.6314 35.3589 16.8485 35.088 16.8485H32.6359C31.826 16.8485 31.1647 17.5013 31.1647 18.303C31.1647 19.1048 31.8255 19.7576 32.6391 19.7576H36.0675C36.5349 19.7576 37.2906 19.5813 37.7072 19.3754L41.7346 17.3845C41.9769 17.2648 42.2714 17.3619 42.3926 17.6014C42.5137 17.8409 42.4155 18.1321 42.1732 18.2518L38.1458 20.2427C38.0343 20.2978 37.9085 20.3504 37.7735 20.3992C39.512 22.531 40.4828 25.1911 40.4828 28C40.4828 32.5815 37.8883 36.7019 33.8601 38.7664C33.8547 39.5758 33.4362 40.364 32.6822 40.8165L28.3378 43.4243C27.7976 43.7485 26.8921 44 26.2621 44H14.4905C14.2197 44 14.0001 43.7829 14.0001 43.5152C14.0001 43.2474 14.2197 43.0303 14.4905 43.0303H26.2621C26.7122 43.0303 27.4417 42.8277 27.8288 42.5954L32.1732 39.9877C32.8432 39.5855 33.0706 38.744 32.7065 38.0735C32.2607 37.4433 31.3795 37.2456 30.6984 37.6383L27.3509 39.5689C26.809 39.8814 25.9112 40.1212 25.2807 40.1212H21.3564C21.221 40.1212 21.0984 40.0669 21.0096 39.9792ZM16.9426 28C16.9426 30.7361 17.9427 33.3166 19.7227 35.3314C19.9582 35.2934 20.1818 35.2727 20.3769 35.2727H23.8053C25.1605 35.2727 26.2606 36.3594 26.2606 37.697C26.2606 38.2083 26.0983 38.6918 25.8137 39.0911C26.1912 39.0165 26.5974 38.8808 26.8567 38.7313L30.2436 36.7781C31.348 36.1411 32.7725 36.4598 33.4952 37.4921L33.4982 37.4902L33.5901 37.6379L33.5871 37.6398C33.6115 37.6842 33.6344 37.7294 33.6559 37.775C37.2209 35.8358 39.5019 32.1208 39.5019 28C39.5019 25.2639 38.5019 22.6834 36.7218 20.6686C36.4864 20.7066 36.2628 20.7273 36.0676 20.7273H32.6392C31.2841 20.7273 30.184 19.6406 30.184 18.303C30.184 17.7843 30.3495 17.3033 30.631 16.9088C30.2534 16.9835 29.8472 17.1192 29.5879 17.2687L26.2403 19.1993C25.1247 19.8426 23.6929 19.5286 22.9516 18.5066L22.9464 18.5098C22.931 18.4851 22.9162 18.4603 22.9018 18.4353C22.8857 18.4112 22.8699 18.3868 22.8545 18.3621L22.8597 18.3589C22.8361 18.314 22.8139 18.2685 22.7932 18.2225C19.2256 20.161 16.9426 23.8774 16.9426 28Z",
    fill: "url(#paint13_linear_0_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7744 18.5146C22.7583 18.4905 22.7425 18.4661 22.7271 18.4413L22.7221 18.4333C19.2835 20.367 17.0926 23.989 17.0926 28C17.0926 30.6712 18.0588 33.192 19.7812 35.1707L22.7744 18.5146ZM22.7744 18.5146C22.7888 18.5396 22.8037 18.5644 22.819 18.589L22.8975 18.7151L22.9146 18.7047C23.7213 19.7006 25.1741 19.9873 26.3153 19.3292L29.6628 17.3986C29.8283 17.3032 30.0642 17.2113 30.3152 17.1395C30.1354 17.489 30.034 17.8845 30.034 18.303C30.034 19.7252 31.203 20.8773 32.6392 20.8773H36.0676C36.2492 20.8773 36.4518 20.8603 36.6633 20.8293C38.3858 22.808 39.3519 25.3288 39.3519 28C39.3519 32.011 37.161 35.633 33.7225 37.5667L22.7744 18.5146ZM18.7221 35.7418L18.9209 35.6698L18.7873 35.5059C17.0703 33.4005 16.1118 30.7739 16.1118 28C16.1118 23.4908 18.657 19.4327 22.6361 17.3771L22.717 17.3353L22.7172 17.2442C22.7191 16.4823 23.1115 15.7388 23.8224 15.3121L28.1668 12.7044C28.6837 12.394 29.5626 12.15 30.1653 12.15H41.9369C42.1265 12.15 42.2773 12.3015 42.2773 12.4848C42.2773 12.6682 42.1265 12.8197 41.9369 12.8197H30.1653C29.9217 12.8197 29.6124 12.8738 29.3182 12.9555C29.0239 13.0372 28.7307 13.1504 28.5214 13.276L24.177 15.8837C23.4388 16.3268 23.1863 17.2563 23.5891 17.9981L23.5933 18.0059L23.5985 18.0132C24.0891 18.7066 25.0559 18.923 25.8039 18.4916L29.1515 16.561C29.6704 16.2618 30.5424 16.0288 31.1467 16.0288H35.088C35.2777 16.0288 35.4285 16.1803 35.4285 16.3636C35.4285 16.547 35.2777 16.6985 35.088 16.6985H32.6359C31.7449 16.6985 31.0147 17.4168 31.0147 18.303C31.0147 19.1895 31.7445 19.9076 32.6391 19.9076H36.0675C36.3168 19.9076 36.6347 19.8611 36.9404 19.7898C37.2461 19.7185 37.5513 19.6197 37.7736 19.5098L41.8011 17.519C41.9704 17.4353 42.1752 17.5038 42.2587 17.6691C42.3418 17.8333 42.2752 18.0341 42.1068 18.1174L38.0793 20.1082C37.9738 20.1604 37.8533 20.2108 37.7224 20.2582L37.5236 20.3302L37.6572 20.494C39.3742 22.5994 40.3328 25.2261 40.3328 28C40.3328 32.5238 37.771 36.5934 33.7917 38.6329L33.7108 38.6744L33.7102 38.7654C33.705 39.5239 33.313 40.263 32.605 40.6879L28.2606 43.2956C27.7437 43.606 26.8648 43.85 26.2621 43.85H14.4905C14.3009 43.85 14.1501 43.6985 14.1501 43.5152C14.1501 43.3318 14.3009 43.1803 14.4905 43.1803H26.2621C26.5057 43.1803 26.815 43.1262 27.1092 43.0445C27.4035 42.9628 27.6967 42.8496 27.906 42.724L32.2504 40.1163C32.9886 39.6732 33.2411 38.7437 32.8383 38.0019L32.8341 37.9941L32.829 37.9868C32.3384 37.2934 31.3716 37.077 30.6235 37.5084L27.2759 39.439C26.757 39.7382 25.8851 39.9712 25.2807 39.9712H21.3564C21.2618 39.9712 21.1767 39.9335 21.1151 39.8725C21.0535 39.8116 21.016 39.7283 21.016 39.6364C21.016 39.453 21.1668 39.3015 21.3564 39.3015H23.8085C24.6996 39.3015 25.4298 38.5832 25.4298 37.697C25.4298 36.8105 24.6999 36.0924 23.8053 36.0924H20.3769C20.1277 36.0924 19.8097 36.1389 19.504 36.2102C19.1983 36.2815 18.8931 36.3803 18.6708 36.4902L14.6434 38.481C14.4741 38.5647 14.2693 38.4962 14.1857 38.3309C14.1027 38.1667 14.1693 37.9659 14.3377 37.8826L18.3651 35.8918C18.4706 35.8396 18.5912 35.7891 18.7221 35.7418ZM19.6103 35.4307L19.665 35.4927L19.7466 35.4795C19.9763 35.4424 20.1917 35.4227 20.3769 35.4227H23.8053C25.0794 35.4227 26.1106 36.444 26.1106 37.697C26.1106 38.1762 25.9585 38.6294 25.6916 39.0041L25.4725 39.3115L25.8428 39.2383C26.23 39.1617 26.6534 39.0217 26.9316 38.8612L30.3185 36.908C31.3558 36.3098 32.6944 36.6097 33.3723 37.5781L33.4074 37.6282L33.4262 37.6585L33.4556 37.712C33.4785 37.7537 33.5 37.7959 33.52 37.8387L33.5876 37.9829L33.7275 37.9068C37.3396 35.942 39.6519 32.1771 39.6519 28C39.6519 25.2268 38.6382 22.6111 36.8342 20.5693L36.7795 20.5073L36.6979 20.5205C36.4682 20.5576 36.2529 20.5773 36.0676 20.5773H32.6392C31.3651 20.5773 30.334 19.556 30.334 18.303C30.334 17.8168 30.489 17.3661 30.7531 16.996L30.9726 16.6884L30.6019 16.7617C30.2147 16.8383 29.7912 16.9783 29.5129 17.1388L26.1654 19.0693C25.1163 19.6743 23.7693 19.3783 23.073 18.4185L23.0352 18.3663C23.0341 18.3644 23.033 18.3625 23.0319 18.3606L23.0322 18.3604L23.0263 18.3516C23.025 18.3497 23.0238 18.3478 23.0225 18.346L22.9924 18.2889C22.9702 18.2468 22.9494 18.2042 22.9301 18.161L22.8638 18.0135L22.7216 18.0907C19.1069 20.0548 16.7926 23.8211 16.7926 28C16.7926 30.7732 17.8064 33.3889 19.6103 35.4307Z",
    stroke: "url(#paint14_linear_0_214)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_214",
    x: -10,
    y: -10,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_214",
    x: 4.9,
    y: 7.9,
    width: 54.2,
    height: 54.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.55,
    result: "effect1_foregroundBlur_0_214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_214",
    x: -8.7,
    y: 3.3,
    width: 51.4,
    height: 51.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.85,
    result: "effect1_foregroundBlur_0_214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_0_214",
    x: 12.9304,
    y: 18.5233,
    width: 29.4418,
    height: 22.8256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_214",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_0_214",
    x: 8,
    y: 6,
    width: 40.4445,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_214",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_214"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_214",
    x1: 17,
    y1: 34.5,
    x2: 52,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3148 18.0413) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_214",
    x1: 26,
    y1: 35,
    x2: 38,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1079 29.357) rotate(44.0741) scale(16.2963 26.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_214",
    x1: 6,
    y1: 21.5,
    x2: 41,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.31482 5.04132) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_214",
    x1: 11,
    y1: 29,
    x2: 23,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1079 23.357) rotate(44.0741) scale(16.2963 26.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_214",
    x1: 19.6281,
    y1: 20.9884,
    x2: 37.6135,
    y2: 28.2268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_0_214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6693 23.8467) rotate(78.9986) scale(11.7879 33.9757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9870E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465667,
    stopColor: "#4C25B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#531CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_214",
    x1: 19.4754,
    y1: 25.0154,
    x2: 36.3722,
    y2: 25.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_214",
    x1: 14,
    y1: 28,
    x2: 42.4444,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_214",
    x1: 14.8889,
    y1: 13.4545,
    x2: 42.4444,
    y2: 13.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline4);
export default __webpack_public_path__ + "static/media/IconTimeline4.c3b2a2f05a28af02653e5fa6be8c2716.svg";
export { ForwardRef as ReactComponent };